import React from 'react'
import { useTheme } from '@mui/material/styles';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';

function Logo() {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Link to='/'>
    <Box display='flex' alignItems='center'>
            <img src='/test_master_logo_dark 1.png' alt="Berry" width="100" />
            <Box display='flex' flexDirection='column'>
            <Typography flexWrap color='black' variant='h3'>Test</Typography> 
            <Typography flexWrap color='black' variant='h3'>Masters</Typography> 
            </Box>
        </Box>
        </Link>
  )
}

export default Logo